import { A } from '@adornis/base/env-info.js';
import { delay, formatIfDefined } from '@adornis/bh-util/util.js';
import { exportWorkshopParticipantsCSV } from '@adornis/buchungsheld-db/api/workshop.js';
import type { WorkshopParticipationExportPlugin } from '@adornis/buchungsheld-db/db-plugins.js';
import type { BHTranslationDictionary } from '@adornis/buchungsheld-db/translations/translation.js';
import type { ChemistryLitElement } from '@adornis/chemistry/chemistry-lit-element.js';
const _XNativeDialog = () => import('@adornis/dialog/x-native-dialog.js').then(m => m.XNativeDialog);
import { downloadLink } from '@adornis/file-utils/client/helper-methods.js';
import type { TranslationController } from '@adornis/translation-core/client/translation-controller.js';
import { html } from 'lit';

export const defaultWorkshopParticipationExportPlugin: WorkshopParticipationExportPlugin = {
  id: 'workshop-participation-export::default',
  type: 'workshop-participation-export',
  render: (
    host: ChemistryLitElement,
    translation: TranslationController<BHTranslationDictionary>,
    institutionID: string,
    workshop,
  ) => html`
    <x-flex space="md">
      <x-h3> Import / Export </x-h3>
      <x-flex horizontal space="md">
        <x-button
          mode="outline"
          icon="download"
          @click=${async () => {
            let exportFileName = workshop.name;
            const startDate = formatIfDefined(workshop.appointments.at(0)?.start, 'yyyy-MM-dd');
            const endDate = formatIfDefined(workshop.appointments.at(-1)?.start, 'yyyy-MM-dd');
            if (startDate) exportFileName += ` ${startDate}`;
            if (endDate && startDate !== endDate) exportFileName += ` - ${endDate}`;
            exportFileName += '.csv';

            try {
              await (await _XNativeDialog()).waitFor(
                Promise.all([
                  exportWorkshopParticipantsCSV(workshop._id, false)().then(fileName =>
                    downloadLink(A.absoluteUrl(`/__export/download/${fileName}`), exportFileName),
                  ),
                  delay(500),
                ]),
              );
            } catch (e) {
              if ((e as any).message === 'file is empty') {
                await (await _XNativeDialog()).alert(translation.translate('imp_exp', 'no_data_found'));
              } else {
                await (await _XNativeDialog()).alert(translation.translate('workshop', 'export_err'));
              }
            }
          }}
        >
          ${translation.translate('imp_exp', 'exp_participants')}
        </x-button>
      </x-flex>
    </x-flex>
  `,
};
